import React from "react";
import { Link } from "react-router-dom";

const cards = [
  { to: "/cadastros/entidades", title: "Entidades PF/PJ" },
  { to: "/cadastros/fornecedores", title: "Fornecedores" },
  { to: "/cadastros/clientes", title: "Clientes" },
  { to: "/cadastros/bancos", title: "Bancos" },
  { to: "/cadastros/contas-bancarias", title: "Contas bancarias" },
  { to: "/cadastros/centros-custo", title: "Centros de custo" },
  { to: "/cadastros/plano-contas", title: "Plano de contas" },
  { to: "/cadastros/categorias", title: "Categorias" },
];

export const CadastrosHome: React.FC = () => {
  return (
    <div className="container py-4">
      <h1 className="mb-3">Cadastros base</h1>
      <p className="text-muted">
        Use a busca digitada para encontrar registros. Todos os cadastros usam
        paginação server-side.
      </p>
      <div className="row g-3">
        {cards.map((card) => (
          <div className="col-md-6 col-lg-4" key={card.to}>
            <div className="card shadow-sm h-100">
              <div className="card-body d-flex flex-column">
                <h5 className="card-title">{card.title}</h5>
                <Link to={card.to} className="btn btn-outline-primary mt-auto">
                  Acessar
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
